$('.faq-group .question').on('click', function(){
   $(this).closest('.faq-group').find('.answer').slideUp(500);
   $(this).closest('.faq-group').find('.single').removeClass('active');
   if(!$(this).next('.answer').is(':visible')) {
       $(this).next('.answer').slideDown(500);
       $(this).closest('.single').addClass('active');
   }
});